module.exports = __webpack_public_path__ + "static/mascot-maintenance-3964cdc0447c08429ca5877ac579e8d6.png";